import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getActividad,
  getErroneosByOrigenDestino,
  getErroneos,
  updateErroneo,
  getProcesados,
  getInstancias,
  updateInstancia,
} from '../../services/sync'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_ACTIVIDAD() {
  try {
    const ActividadData = yield call(getActividad)
    if (ActividadData.ok) {
      yield put({
        type: actions.ACTIVIDAD_LOAD_SUCCEEDED,
        payload: ActividadData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Actividad')
      put({
        type: actions.ACTIVIDAD_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ACTIVIDAD_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ERRONEOS() {
  try {
    const ActividadData = yield call(getErroneos)
    if (ActividadData.ok) {
      yield put({
        type: actions.ERRONEOS_LOAD_SUCCEEDED,
        payload: ActividadData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar erroneos')
      put({
        type: actions.ERRONEOS_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ERRONEOS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ERRONEOS_BY_ORIGEN_DESTINO({ payload }) {
  try {
    const ErroneosData = yield call(
      getErroneosByOrigenDestino,
      payload.entidadOrigen,
      payload.entidadDestino,
    )
    if (ErroneosData.ok) {
      yield put({
        type: actions.ERRONEOS_BY_ORIGEN_DESTINO_LOAD_SUCCEEDED,
        payload: ErroneosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Erroneos')
      put({
        type: actions.ERRONEOS_BY_ORIGEN_DESTINO_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ERRONEOS_BY_ORIGEN_DESTINO_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ERRONEO({ payload }) {
  try {
    const ErroneosData = yield call(updateErroneo, payload)
    if (ErroneosData.ok) {
      putMessage(messageType.SUCCESS, 'Hecho!')
      yield put({
        type: actions.UPDATE_ERRONEO_SUCCEEDED,
        payload: ErroneosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Erroneos')
      put({
        type: actions.ERRONEO_UPDATE_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ERRONEO_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_PROCESADOS() {
  try {
    const ProcesadosData = yield call(getProcesados)
    if (ProcesadosData.ok) {
      yield put({
        type: actions.PROCESADOS_LOAD_SUCCEEDED,
        payload: ProcesadosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar procesados')
      put({
        type: actions.PROCESADOS_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PROCESADOS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_INSTANCIAS() {
  try {
    const ProcesadosData = yield call(getInstancias)
    if (ProcesadosData.ok) {
      yield put({
        type: actions.INSTANCIA_LOAD_SUCCEEDED,
        payload: ProcesadosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar instancias')
      put({
        type: actions.INSTANCIA_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.INSTANCIA_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_INSTANCIA({ payload }) {
  try {
    const ErroneosData = yield call(updateInstancia, payload)
    if (ErroneosData.ok) {
      putMessage(messageType.SUCCESS, 'Hecho!')
      yield put({
        type: actions.UPDATE_INSTANCIA_SUCCEEDED,
        payload: ErroneosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar instancia')
      put({
        type: actions.INSTANCIA_UPDATE_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.INSTANCIA_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.ACTIVIDAD_LOAD_REQUESTED, GET_ACTIVIDAD)])
  yield all([takeEvery(actions.ERRONEOS_LOAD_REQUESTED, GET_ERRONEOS)])
  yield all([
    takeEvery(actions.ERRONEOS_BY_ORIGEN_DESTINO_LOAD_REQUESTED, GET_ERRONEOS_BY_ORIGEN_DESTINO),
  ])
  yield all([takeEvery(actions.ERRONEO_UPDATE_REQUESTED, UPDATE_ERRONEO)])
  yield all([takeEvery(actions.PROCESADOS_LOAD_REQUESTED, GET_PROCESADOS)])
  yield all([takeEvery(actions.INSTANCIA_LOAD_REQUESTED, GET_INSTANCIAS)])
  yield all([takeEvery(actions.INSTANCIA_UPDATE_REQUESTED, UPDATE_INSTANCIA)])
}
